import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
const acronym = [{
  letter: 'C',
  bold: 'Calidad real',
  rest: ', no relleno barato.'
}, {
  letter: 'O',
  bold: 'Origen nacional',
  rest: ': fabricación propia en Argentina.'
}, {
  letter: 'F',
  bold: 'Fórmula propia',
  rest: ', desarrollada por nosotros.'
}, {
  letter: 'I',
  bold: 'Identidad',
  rest: ' certificada por ANMAT.'
}, {
  letter: 'T',
  bold: 'Trazabilidad',
  rest: ': registro RNE habilitado.'
}];
// Ficha técnica con valores reservados: la receta no se entrega en la web.
const sheet = [{
  label: 'Proteína por porción',
  value: 'En la etiqueta'
}, {
  label: 'Azúcar agregada',
  value: 'No'
}, {
  label: 'Fórmula',
  value: 'Propia'
}, {
  label: 'Origen',
  value: 'Industria Argentina'
}, {
  label: 'Registro',
  value: 'RNE · ANMAT ✓'
}, {
  label: 'Composición completa',
  value: '•••••'
}];
export function LabelSection() {
  return <section className="bg-cream py-[90px] text-ink" data-id="element-57">
      <div className="mx-auto max-w-[1100px] px-6" data-id="element-58">
        <Reveal data-id="element-59">
          <Eyebrow tone="dark" data-id="element-60">MÁS QUE UNA PROTEÍNA</Eyebrow>
        </Reveal>
        <div className="mt-[26px] grid grid-cols-1 items-start gap-[50px] lg:grid-cols-[0.85fr_1.15fr]" data-id="element-61">
          <Reveal data-id="element-62">
            <h2 className="max-w-[440px] text-[clamp(24px,3.6vw,36px)] leading-[1.1] text-ink" data-id="element-63">
              LO QUE IMPORTA NO SE COPIA CON UNA IA. ESTÁ EN LOS PAPELES.
            </h2>
            <div className="mt-[26px] flex flex-col gap-4" data-id="element-64">
              {acronym.map(row => <div key={row.letter} className="flex items-start gap-4" data-id="element-65">
                  <div className="min-w-[34px] font-display text-[32px] text-camel" data-id="element-66">
                    {row.letter}
                  </div>
                  <div className="pt-1.5 text-[15.5px] font-semibold" data-id="element-67">
                    <b className="font-extrabold text-ink" data-id="element-68">{row.bold}</b>
                    {row.rest}
                  </div>
                </div>)}
            </div>
          </Reveal>

          <Reveal className="flex flex-col gap-[22px] sm:flex-row sm:items-stretch" data-id="element-69">
            <span className="hidden font-display text-[15px] tracking-[6px] text-camel sm:block" style={{
            writingMode: 'vertical-rl',
            transform: 'rotate(180deg)'
          }} aria-hidden="true" data-id="element-70">
              MÁS QUE UNA PROTEÍNA
            </span>
            <div className="max-w-[380px] flex-1 border-t-4 border-camel bg-white px-6 pb-5 pt-6" data-id="element-71">
              <div className="mb-3 flex items-center justify-between border-b-2 border-ink pb-2.5" data-id="element-72">
                <span className="font-mono text-[11px] font-bold uppercase tracking-[1.5px] text-ink" data-id="element-73">
                  Ficha técnica
                </span>
                <span className="bg-ink px-2.5 py-1.5 font-display text-[11px] tracking-[0.5px] text-white" data-id="element-74">
                  ANMAT ✓
                </span>
              </div>
              {sheet.map((row, i) => <div key={row.label} className={`flex justify-between gap-3 py-[7px] font-mono text-[13.5px] text-ink ${i < sheet.length - 1 ? 'border-b border-dashed border-ink/25' : ''}`} data-id="element-75">
                  <span data-id="element-76">{row.label}</span>
                  <b className="font-bold" data-id="element-77">{row.value}</b>
                </div>)}
              <p className="mt-3.5 text-[11px] leading-[1.5] text-ink/60" data-id="element-78">
                La ficha completa y la composición se comparten con la lista de
                espera, antes del lanzamiento. La web no es el producto: el
                producto está aprobado bajo registro RNE habilitado por ANMAT.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}